<template>
  <div class="reports-page">
    <div class="page-header">
      <h2>运营报表</h2>
      <div class="header-actions">
        <el-select
          v-model="timeRange"
          placeholder="时间范围"
          class="time-select"
        >
          <el-option label="本周" value="week"></el-option>
          <el-option label="本月" value="month"></el-option>
          <el-option label="本季度" value="quarter"></el-option>
          <el-option label="本年度" value="year"></el-option>
        </el-select>
        <el-button type="primary" class="export-btn">
          <i class="el-icon-download"></i> 导出报表
        </el-button>
      </div>
    </div>
    <div class="stats-grid">
      <el-card class="stat-card">
        <div class="stat-icon blue">
          <i class="el-icon-trending-up"></i>
        </div>
        <div class="stat-info">
          <p class="stat-value">¥128,650</p>
          <p class="stat-label">总收入</p>
          <p class="stat-change positive">+12.5%</p>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-icon green">
          <i class="el-icon-shopping-cart"></i>
        </div>
        <div class="stat-info">
          <p class="stat-value">256</p>
          <p class="stat-label">订单数量</p>
          <p class="stat-change positive">+8.3%</p>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-icon orange">
          <i class="el-icon-users"></i>
        </div>
        <div class="stat-info">
          <p class="stat-value">1,892</p>
          <p class="stat-label">用户增长</p>
          <p class="stat-change positive">+15.2%</p>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-icon purple">
          <i class="el-icon-percentage"></i>
        </div>
        <div class="stat-info">
          <p class="stat-value">96.8%</p>
          <p class="stat-label">满意度</p>
          <p class="stat-change positive">+2.1%</p>
        </div>
      </el-card>
    </div>
    <div class="charts-row">
      <el-card class="chart-card">
        <h3>订单趋势</h3>
        <div class="chart-placeholder">
          <div class="mini-chart">
            <div class="bar" style="height: 40%"></div>
            <div class="bar" style="height: 65%"></div>
            <div class="bar" style="height: 45%"></div>
            <div class="bar" style="height: 80%"></div>
            <div class="bar" style="height: 55%"></div>
            <div class="bar" style="height: 90%"></div>
            <div class="bar" style="height: 70%"></div>
          </div>
          <div class="chart-labels">
            <span>周一</span>
            <span>周二</span>
            <span>周三</span>
            <span>周四</span>
            <span>周五</span>
            <span>周六</span>
            <span>周日</span>
          </div>
        </div>
      </el-card>
      <el-card class="chart-card">
        <h3>线路销量排行</h3>
        <div class="ranking-list">
          <div
            class="ranking-item"
            v-for="(item, index) in rankingData"
            :key="index"
          >
            <span :class="['rank', index < 3 ? 'top' : '']">{{
              index + 1
            }}</span>
            <div class="item-info">
              <span class="item-name">{{ item.name }}</span>
              <span class="item-count">{{ item.count }}单</span>
            </div>
            <div class="progress-bar">
              <div
                class="progress-fill"
                :style="{ width: item.percent + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="bottom-row">
      <el-card class="chart-card">
        <h3>地域分布</h3>
        <div class="region-grid">
          <div
            class="region-item"
            v-for="region in regionData"
            :key="region.name"
          >
            <span class="region-name">{{ region.name }}</span>
            <span class="region-value">{{ region.value }}</span>
          </div>
        </div>
      </el-card>
      <el-card class="chart-card">
        <h3>热门活动</h3>
        <div class="activity-list">
          <div
            class="activity-item"
            v-for="activity in activityData"
            :key="activity.id"
          >
            <div class="activity-image">
              <img :src="activity.image" :alt="activity.name" />
            </div>
            <div class="activity-info">
              <span class="activity-name">{{ activity.name }}</span>
              <span class="activity-date">{{ activity.date }}</span>
            </div>
            <span class="activity-status">{{ activity.status }}</span>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reports",
  data() {
    return {
      timeRange: "month",
      rankingData: [
        { name: "武功山3日穿越", count: 156, percent: 100 },
        { name: "梅里雪山滇藏朝圣", count: 128, percent: 82 },
        { name: "四姑娘山二峰冲顶", count: 98, percent: 63 },
        { name: "秦岭西梁入门行", count: 76, percent: 49 },
        { name: "祁连山深度徒步", count: 54, percent: 35 }
      ],
      regionData: [
        { name: "华东地区", value: "28%" },
        { name: "西南地区", value: "25%" },
        { name: "华北地区", value: "18%" },
        { name: "华南地区", value: "15%" },
        { name: "其他地区", value: "14%" }
      ],
      activityData: [
        {
          id: 1,
          name: "五一徒步特惠活动",
          date: "2025-05-01",
          status: "进行中",
          image:
            "https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=mountain%20hiking%20activity&image_size=landscape_4_3"
        },
        {
          id: 2,
          name: "端午登山节",
          date: "2025-06-07",
          status: "即将开始",
          image:
            "https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=dragon%20boat%20festival%20mountain&image_size=landscape_4_3"
        },
        {
          id: 3,
          name: "暑期夏令营",
          date: "2025-07-15",
          status: "预热中",
          image:
            "https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=summer%20camp%20outdoor&image_size=landscape_4_3"
        }
      ]
    };
  }
};
</script>

<style scoped>
.reports-page {
  padding: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.time-select {
  width: 140px;
}

.export-btn {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  border: none;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.stat-icon.blue {
  background-color: #dbeafe;
}

.stat-icon.blue i {
  color: #2563eb;
}

.stat-icon.green {
  background-color: #dcfce7;
}

.stat-icon.green i {
  color: #16a34a;
}

.stat-icon.orange {
  background-color: #fed7aa;
}

.stat-icon.orange i {
  color: #ea580c;
}

.stat-icon.purple {
  background-color: #e9d5ff;
}

.stat-icon.purple i {
  color: #9333ea;
}

.stat-icon i {
  font-size: 24px;
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.stat-label {
  font-size: 13px;
  color: #6b7280;
  margin: 4px 0 0 0;
}

.stat-change {
  font-size: 12px;
  margin: 4px 0 0 0;
}

.stat-change.positive {
  color: #16a34a;
}

.stat-change.negative {
  color: #ef4444;
}

.charts-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.bottom-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.chart-card {
  padding: 20px;
  border-radius: 12px;
}

.chart-card h3 {
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.chart-placeholder {
  height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mini-chart {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 120px;
  padding: 0 20px;
}

.bar {
  width: 28px;
  background: linear-gradient(180deg, #22c55e 0%, #16a34a 100%);
  border-radius: 4px 4px 0 0;
}

.chart-labels {
  display: flex;
  justify-content: space-around;
  padding: 0 20px;
  margin-top: 10px;
}

.chart-labels span {
  font-size: 12px;
  color: #9ca3af;
}

.ranking-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ranking-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rank {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.rank.top {
  background-color: #22c55e;
  color: #fff;
}

.item-info {
  flex: 1;
  display: flex;
  justify-content: space-between;
}

.item-name {
  font-size: 13px;
  color: #374151;
}

.item-count {
  font-size: 13px;
  color: #9ca3af;
}

.progress-bar {
  width: 120px;
  height: 6px;
  background-color: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #22c55e, #16a34a);
  border-radius: 3px;
}

.region-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.region-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #f9fafb;
  border-radius: 8px;
}

.region-name {
  font-size: 13px;
  color: #6b7280;
}

.region-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.activity-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 8px;
}

.activity-image {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.activity-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.activity-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.activity-name {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
}

.activity-date {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
}

.activity-status {
  font-size: 12px;
  padding: 4px 10px;
  background-color: #dcfce7;
  color: #16a34a;
  border-radius: 12px;
}

@media (max-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .charts-row,
  .bottom-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
